import React, { useEffect, useState } from "react";
import { colors } from "../../../constants/constants";
import SimplexNoise from "simplex-noise";
import { useWindowSize } from "../../../hooks/useWindowSize";
import { useSpring, animated, config } from "react-spring";
import { useMargins } from "../../../hooks/hooks";

const simplex = new SimplexNoise();

const Dot = ({
  x,
  y,
  t,
  range,
  dotStyle,
}: {
  x: number;
  y: number;
  t: number;
  range: number;
  dotStyle?: React.CSSProperties;
}) => {
  const { h } = useWindowSize();

  const { marginTop } = useSpring({
    from: { marginTop: h(0) },
    to: { marginTop: h(simplex.noise3D(x, y, t) * range) },
    config: {
      tension: 280,
      friction: 180,
    },
  });

  return (
    <animated.div
      id=""
      className=""
      {...{
        style: {
          height: h(1),
          width: h(0.25),
          background: colors.pink,
          marginTop,
          placeSelf: "center",
          ...dotStyle,
        },
      }}
    />
  );
};

export const Lines = ({
  gridArea,
  noise = false,
  numberOfLines = 20,
  numberOfDotsPerLines = 8,
  range = 40,
  timeRange = 500,
  timeIntervalMilliseconds = 2500,
  containerStyle,
  dotStyle,
}: {
  gridArea?: string;
  noise?: boolean;
  numberOfLines?: number;
  numberOfDotsPerLines?: number;
  range?: number;
  timeRange?: number;
  timeIntervalMilliseconds?: number;
  containerStyle?: React.CSSProperties;
  dotStyle?: React.CSSProperties;
}) => {
  const [time, timeSet] = useState(0);

  useEffect(() => {
    const id = setTimeout(() => {
      timeSet(time + timeIntervalMilliseconds);
    }, timeIntervalMilliseconds);

    return () => clearTimeout(id);
  });

  console.log({ time });
  const { screenContentVerticalPadding, screenContentHorizontalPadding } =
    useMargins();

  return (
    <div
      id="Lines"
      style={{
        gridArea,
        pointerEvents: "none",
        padding: `0 ${screenContentHorizontalPadding}`,
        display: "flex",
        justifyContent: "space-between",
        ...containerStyle,
      }}
    >
      {[...Array(numberOfLines)].map((_, lineIndex) => (
        <div
          key={lineIndex}
          style={{
            height: "100%",
            width: "1px",
            backgroundColor: "rgba(255,255,255,0.05)",
            display: "grid",
          }}
        >
          {noise &&
            [...Array(numberOfDotsPerLines)].map((_, dotIndex) => {
              return (
                <Dot
                  {...{
                    x: dotIndex / numberOfDotsPerLines,
                    y: lineIndex / numberOfLines,
                    t: (time / 100000) * timeRange,
                    range,
                    dotStyle,
                  }}
                />
              );
            })}
        </div>
      ))}
    </div>
  );
};
